interface PaymentItem {
    item: PaymentItemType;
    type: string;
}

export interface PaymentItemType {
    currency: 'DOLLAR' | 'EURO';
    discount: number;
    discountedPrice: string;
    id: number;
    price: string;
    updatedAt: string;
    image: string;
    description: string;
    promoText: string;
    credits: number;
    createdAt: string;
}
export interface PaymentStoreProps {
    items: PaymentItem[];
    total: any | null;
}

export interface PaymentStoreContextState {
    paymentCart: PaymentStoreProps[];

    setPaymentCart: (paymentCart: PaymentStoreProps[]) => any;
}

export const defaultPaymentStoreState: PaymentStoreContextState = {
    paymentCart: [],
    setPaymentCart: () => {},
};
